const isSm = '@media (max-width: 599.95px)'
const isMd = '@media (max-width: 899.95px)'

export { isSm, isMd }
